import { render, staticRenderFns } from "./CreateEventDialog.vue?vue&type=template&id=185c07ce&scoped=true&lang=pug&"
import script from "./CreateEventDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateEventDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEventDialog.vue?vue&type=style&index=0&id=185c07ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c07ce",
  null
  
)

export default component.exports